import React from 'react'
import StyleBox from '../StyleBox'
import builderExample from '../../assets/nail-builder.jpeg'
import './Services.scss'

export default function NailServices() {
	const builderDescription = `Builder gel is a thicker more structured gel applied to add strength and to rebalance
		the shape of the natural nails. This set is a more natural looking alternative to acrylic and great for those
		with an allergy to acrylic powder products.`
	return (
		<div className='NailServices Services page-content-wrapper'>
			<div className='page-content'>
				<div className='services-style-gallery'>
					<StyleBox
						title='Builder gel'
						imageSrc={builderExample}
						imageAlt='Builder gel nails'
						description={builderDescription} />
				</div>
				<p>Currently I am only focused on builder gel for nails.</p>
			</div>
		</div>
	)
}